// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1dzfY","infoBtn":"quickbooks_infoBtn__3SYKv","formBox":"quickbooks_formBox__3SZJd","formFooter":"quickbooks_formFooter__2KZm8"};